import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import Vue from 'vue';
import Drip from 'drip';
import AD from 'drip/Ad';
import Url from 'drip/utils/url';
import KNB from '@dp/knb';
var Constant = Drip.constant;
Vue.mixin({
  data: function data() {
    return {
      Env: Drip,
      Constant: Constant
    };
  },
  methods: {
    imgErr: function imgErr(e) {
      // 统一图片错误处理
      e.currentTarget.style.display = 'none';
    },
    back: function back() {
      var _Drip$UA;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (page && typeof page === 'string') {
        this.$router.go(page);
      } else if (history.length > 1) {
        this.$router.go(-1);
      } else if (window.__wxjs_environment === 'miniprogram') {
        wx.miniProgram.navigateBack();
      } else if (Drip.UA.IS_DouyinShowMicroApp) {
        window.tt.miniProgram.navigateBack();
      } else if (Drip.UA.IS_MAOYAN_XHS_APP || Drip.UA.IS_MAOYAN_XHSMOVIE) {
        window.xhs.miniProgram.navigateBack();
      } else if (Drip.UA.IS_MAOYAN_BAIDU_APP) {
        window.swan.webView.navigateBack();
      } else if ((_Drip$UA = Drip.UA) !== null && _Drip$UA !== void 0 && _Drip$UA.IS_BiliShowMicroApp) {
        var _window$bl, _window$bl$miniProgra;
        (_window$bl = window.bl) === null || _window$bl === void 0 ? void 0 : (_window$bl$miniProgra = _window$bl.miniProgram) === null || _window$bl$miniProgra === void 0 ? void 0 : _window$bl$miniProgra.navigateBack();
      } else {
        this.$router.go('/index');
      }
    },
    pageBack: function pageBack() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (Drip.UA.isNative) {
        KNB.closePage();
      } else {
        this.back(page);
      }
    },
    go: function go(url) {
      var _Drip$UA2;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        _blank: false,
        closeLoading: true
      };
      if (['meituanmovie://', 'imeituan://', 'dianping://mrn'].some(function (a) {
        return url.startsWith(a);
      })) {
        // app 内的协议跳转
        location.href = url;
        return;
      }
      if (/^https?:\/\/.*$/.test(url)) {
        // 测试是完整的url
        this.Env.redirect(url);
        return;
      }
      try {
        closeLoading && this.$loading.close();
      } catch (error) {}
      var isDianpingAndMTUrl = /(ping.com|myshow|movieshow|(movieshow(list|order))|i.meituan.com)/.test(url);
      if (window.Drip && window.Drip.UA.IS_WXAPP_MEITUAN) {
        var _this$Env, _this$$router;
        // 美团小程序
        isDianpingAndMTUrl ? this === null || this === void 0 ? void 0 : (_this$Env = this.Env) === null || _this$Env === void 0 ? void 0 : _this$Env.redirect(url) : this === null || this === void 0 ? void 0 : (_this$$router = this.$router) === null || _this$$router === void 0 ? void 0 : _this$$router.push(url);
      } else if (Drip.UA.IS_BiliShowMicroApp) {
        url = isDianpingAndMTUrl ? url : '/myshow/index.html#' + url;
        this.Env.redirect(url);
      } else if (!Drip.UA.isNative && !Drip.UA.IS_TENGJING && !Drip.UA.IS_CMBAPP) {
        var path = {
          path: url,
          query: {}
        };
        options._blank && (path.query._blank = true);
        isDianpingAndMTUrl ? this.Env.redirect(url) : this.$router.push(path);
      } else if (Drip.UA.IS_CMBAPP) {
        var _this$Env2, _this$$router2;
        var utm_source = Url.getHashQuery('utm_source');
        var _path = {
          path: url,
          query: {
            utm_source: utm_source
          }
        };
        options._blank && (_path.query._blank = true);
        isDianpingAndMTUrl ? (_this$Env2 = this.Env) === null || _this$Env2 === void 0 ? void 0 : _this$Env2.redirect(url) : (_this$$router2 = this.$router) === null || _this$$router2 === void 0 ? void 0 : _this$$router2.push(_path);
      } else if ((_Drip$UA2 = Drip.UA) !== null && _Drip$UA2 !== void 0 && _Drip$UA2.IS_SHENZHEN_ICBC) {
        var _utm_source = Url.getHashQuery('utm_source');
        var _path2 = {
          path: url,
          query: {
            utm_source: _utm_source
          }
        };
        options._blank && (_path2.query._blank = true);
        isDianpingAndMTUrl ? this.Env.redirect(url) : this.$router.push(_path2);
      } else if (window.Drip && window.Drip.UA.IS_WXAPP_MEITUAN_PINCHANG) {
        var _this$Env3, _this$$router3;
        // 美团拼场微信小程序渠道，m站，演出内部页面跳转用router
        isDianpingAndMTUrl ? this === null || this === void 0 ? void 0 : (_this$Env3 = this.Env) === null || _this$Env3 === void 0 ? void 0 : _this$Env3.redirect(url) : this === null || this === void 0 ? void 0 : (_this$$router3 = this.$router) === null || _this$$router3 === void 0 ? void 0 : _this$$router3.push(url);
      } else {
        url = isDianpingAndMTUrl ? url : '/myshow/index.html#' + url;
        this.Env.redirect(url);
      }
    },
    /**
     * 兼容跳转小程序的url
     * url: Object
     * eg: {
     *    h5Url: '',
     *    wxPath: '',
     *    wxAppId: '',
     * }
     */
    goWithWx: function goWithWx(url) {
      var IS_WXAPP_MEITUAN_PINCHANG = window.Drip && window.Drip.UA.IS_WXAPP_MEITUAN_PINCHANG;
      if (url.douyinPath && navigator.userAgent.toLowerCase().includes('toutiaomicroapp')) {
        if (window.tt) {
          if (url.douyinPath === '/pages/show/index/index') {
            window.tt.miniProgram.reLaunch({
              url: url.douyinPath
            });
          } else {
            window.tt.miniProgram.navigateTo({
              url: url.douyinPath
            });
          }
        } else {
          var douyinJsSdk = document.createElement('script');
          document.head.appendChild(douyinJsSdk);
          douyinJsSdk.setAttribute('src', 'https://lf1-cdn-tos.bytegoofy.com/goofy/developer/jssdk/jssdk-1.1.0.js');
          douyinJsSdk.onload = function () {
            if (url.douyinPath === '/pages/show/index/index') {
              window.tt.miniProgram.reLaunch({
                url: url.douyinPath
              });
            } else {
              window.tt.miniProgram.navigateTo({
                url: url.douyinPath
              });
            }
          };
        }
      } else if (!(window.Drip && window.Drip.UA.IS_WXAPP_MEITUAN) && !IS_WXAPP_MEITUAN_PINCHANG && url.wxPath && window.__wxjs_environment === 'miniprogram') {
        // 美团微信小程序和美团拼场微信小程序 -- 演出页面是M站内嵌在小程序webview，使用路由跳转。
        if (url.wxPath === '/pages/show/index/index') {
          wx.miniProgram.reLaunch({
            url: url.wxPath,
            appId: url.wxAppId || ''
          });
        } else {
          wx.miniProgram.navigateTo({
            url: url.wxPath,
            appId: url.wxAppId || ''
          });
        }
      } else if (window.Drip && window.Drip.UA.IS_BiliShowMicroApp) {
        if (url.wxPath === '/pages/show/index/index') {
          if (window.bl) {
            if (url.blPath === '/pages/show/index/index') {
              window.bl.miniProgram.reLaunch({
                url: url.blPath
              });
            } else {
              window.bl.miniProgram.navigateTo({
                url: url.blPath
              });
            }
          }
        } else {
          wx.miniProgram.navigateTo({
            url: url.wxPath,
            appId: url.wxAppId || ''
          });
        }
      } else {
        this.go(url.h5Url, {
          _blank: true
        });
      }
    },
    goAdPage: function goAdPage(url) {
      // 跳转运营位投放页面
      Drip.redirect(url);
    }
  }
});